import { useSearchParams } from 'next/navigation';

type UserType = 'user' | 'agency';

// `override` lets a flow (e.g. checkout silently preferring an agency
// account) force the type without needing a `userType` query param.
export function useAuthUserType(override?: UserType) {
  const searchParams = useSearchParams();

  if (override) return override;

  const userType = (searchParams?.get('userType') as UserType) || 'user';

  return userType;
}
